<template>
  <div class="pc_container" :style="personalSidebarStyle">
    <div class="main-container">
      <div ref="personalSidebar" class="sidebar">
        <div
          ref="sidebarSurface"
          class="sidebar-surface"
          aria-hidden="true"
        ></div>
        <el-menu
          ref="menuRef"
          :default-openeds="allSubmenuIndexes"
          :default-active="$route.path"
          background-color="transparent"
          text-color="#606266"
          active-text-color="#4286f5"
          class="side-menu"
          router
        >
          <MenuRecursive
            :menus="menuGroupsWithDisabled"
            :unreadCount="unreadCount"
          ></MenuRecursive>
        </el-menu>
      </div>

      <div ref="personalContent" class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserBalance } from "@/api/user.js";
import { Toast, Dialog } from "vant";
import MenuRecursive from "@/components/pc/MenuRecursive";
import personalSidebarLocale from "@/mixins/personalSidebarLocale";
import { canViewReportData } from "./reportDataPermissions";
import { isWikiReviewerAccount } from "@/utils/wikiReviewer";
import { getWikiReviewAccess } from "@/api/xunzhiKb";
import { menuLabelKeys } from "@/i18n/account/index";
import { priceChannelFlags } from "@/services/price-channel/feature-flags";
import {
  PRICE_CHANNEL_PERSONAL_BASE,
  priceChannelPersonalMenu,
} from "@/services/price-channel/business-navigation";

const FOLLOW_MANAGER_PHONES = [
  "15361667524",
  "13522321935",
  "18664988383",
  "13554946806",
  "15012891556",
];

export default {
  name: "UserPage",
  mixins: [personalSidebarLocale],
  components: {
    MenuRecursive,
  },
  watch: {
    authToken(next, previous) {
      if (priceChannelFlags.readSource !== "spring-api") return;
      if (next === previous) return;
      this.$store.dispatch("priceChannelSession/clear");
      if (next) this.loadPriceChannelIdentity();
    },
  },
  data() {
    return {
      avatarImg: require("@/assets/default-avatar.png"),
      detail: {},
      balance: {
        totalBalance: 0,
        frozenBalance: 0,
        withdrawableBalance: 0,
      },
      // 资产项配置（数据驱动）
      assetItems: [
        { key: "totalBalance", label: "账户余额" },
        { key: "withdrawableBalance", label: "可提现" },
        { key: "frozenBalance", label: "冻结中" },
      ],
      // 菜单组配置（数据驱动）
      originMenuGroups: [
        {
          label: "精选交易",
          index: "/pc/user",
          icon: "truck",
          children: [
            {
              index: "/pc/my/myBalance",
              icon: "balance-pay",
              label: "我的钱包",
            },
            {
              index: "/pc/myxg/reportData",
              icon: "data-analysis",
              label: "数据看板",
            },
            // {
            //   index: "/pc/myxg/myPublishClue?active=0",
            //   icon: "records",
            //   label: "供需信息",
            // },
            {
              index: "/pc/myxg/myTransactionOrder",
              icon: "balance-list-o",
              label: "交易订单",
            },
            {
              index: "/pc/myxg/myGoods",
              icon: "balance-list-o",
              label: "商品中心",
            },
            {
              index: "/pc/myxg/goodsLibrary",
              icon: "cart-o",
              label: "商品库",
            },
            {
              index: "/pc/myxg/myBrand",
              icon: "cart-o",
              label: "品牌管理",
            },
            // {
            //   index: "/pc/myxg/myBuyOrderList?orderStatus=4",
            //   icon: "balance-list-o",
            //   label: "购买订单",
            // },
            // {
            //   index: "/pc/myxg/mySaleOrderList",
            //   icon: "logistics",
            //   label: "销售订单",
            // },
            // {
            //   index: "/pc/myxg/mySaleGoods",
            //   icon: "gift-o",
            //   label: "我是货主",
            // },
            // {
            //   index: "/pc/myxg/myPreOrderList",
            //   icon: "gift-card-o",
            //   label: "我是买家",
            // },
            {
              index: "/pc/myxg/supplierList",
              icon: "friends-o",
              label: "供应商管理",
            },
            {
              index: "/pc/myxg/messageCenter",
              icon: "chat-o",
              label: "消息管理",
            },
            {
              index: "/pc/follow/outboundOrderList",
              icon: "chat-o",
              // 出货管理：显示由menuLabelKeys翻译，权限仍按原标签判断。
              label: "出货管理",
            },
            // {
            //   index: "/pc/myxg/myContractList",
            //   icon: "notes-o",
            //   label: "我的合同",
            // },
            // {
            //   index: "/pc/myxg/myYanHuo",
            //   icon: "logistics",
            //   label: "我的验货",
            // },
            // {
            //   index: "/pc/myxg/myFollowOrderList",
            //   icon: "clock-o",
            //   label: "我的评价",
            // },
          ],
          // [
          //   {
          //     label: "个人中心",
          //     index: "/pc/user", //必须要有字符串index，否则报错
          //     children: [],
          //   },
          //   {
          //     label: "我的服务",
          //     index: "",
          //     children: [
          //       {
          //         index: "/pc/myxg/myYanHuo",
          //         icon: "logistics",
          //         label: "我的验货",
          //       },
          //       {
          //         index: "/pc/myxg/myFollowOrderList",
          //         icon: "clock-o",
          //         label: "我的评价",
          //       },
          //     ],
          //   },
          // ],
        },
        {
          label: "供应需求",
          index: "/pc/supply-demand",
          icon: "box",
          disabled: false,
          children: [
            {
              index: "/pc/supply-demand/supply",
              label: "供应发布",
              disabled: false,
            },
            {
              index: "/pc/supply-demand/demand",
              label: "需求发布",
              disabled: false,
            },
            {
              index: "/pc/supply-demand/simple-supply",
              label: "简洁供应发布",
              disabled: false,
            },
            {
              index: "/pc/supply-demand/simple-demand",
              label: "简洁需求发布",
              disabled: false,
            },
            {
              index: "/pc/supply-demand/batch",
              label: "批量发布",
              disabled: false,
            },
          ],
        },
        {
          label: "客户管理",
          index: "/pc/customer-management/customers",
          icon: "user",
          disabled: false,
          internalOnly: true,
          children: [
            {
              index: "/pc/customer-management/customers",
              label: "我的客户",
              disabled: false,
            },
            {
              index: "/pc/customer-management/orders",
              label: "我的订单",
              disabled: false,
            },
          ],
        },
        {
          label: "合同译文审核",
          index: "/pc/contract-translations",
          icon: "description",
          disabled: false,
          adminOnly: true,
        },
        {
          label: "会员等级",
          index: "/pc/member-level/list",
          icon: "medal",
          disabled: false,
          adminOnly: true,
          children: [
            {
              index: "/pc/member-level/list",
              label: "等级列表",
              disabled: false,
            },
            {
              index: "/pc/member-level/apply",
              label: "等级申请",
              disabled: false,
            },
            {
              index: "/pc/member-level/benefits",
              label: "等级权益",
              disabled: false,
            },
          ],
        },
        {
          label: "会员身份",
          index: "/pc/member-identity/list",
          icon: "user",
          disabled: false,
          adminOnly: true,
          children: [
            {
              index: "/pc/member-identity/list",
              label: "身份列表",
              disabled: false,
            },
            {
              index: "/pc/member-identity/sales",
              label: "业务员",
              disabled: false,
            },
            {
              index: "/pc/member-identity/customer",
              label: "客户",
              disabled: false,
            },
            {
              index: "/pc/member-identity/supplier",
              label: "供应商",
              disabled: false,
            },
            {
              index: "/pc/member-identity/partner",
              label: "合作伙伴",
              disabled: false,
            },
          ],
        },
        {
          label: "竞标管理",
          index: "/pc/bidding-management/list",
          icon: "s-flag",
          disabled: false,
          children: [
            {
              index: "/pc/user/bid-audits",
              label: "竞标审核",
              disabled: false,
              internalOnly: true,
            },
            {
              index: "/pc/bidding-management/list",
              label: "竞标列表",
              disabled: false,
              adminOnly: true,
            },
            {
              index: "/pc/bidding-management/publish",
              label: "发布竞标",
              disabled: false,
              hidden: true,
            },
            {
              index: "/pc/bidding-management/my-bids",
              label: "我的竞标",
              disabled: false,
            },
            {
              index: "/pc/bidding-management/follow",
              label: "我的跟单员",
              disabled: false,
            },
            {
              index: "/pc/bidding-management/favorites",
              label: "我的收藏",
              disabled: false,
            },
          ],
        },
        {
          label: "知识百科",
          index: "/pc/user/wiki",
          icon: "search",
          disabled: false,
          children: [
            {
              index: "/pc/user/wiki",
              label: "审核管理",
              disabled: false,
            },
            {
              index: "/pc/user/wiki/mine",
              label: "我的发布",
              disabled: false,
            },
            {
              index: "/pc/user/wiki/collection",
              label: "我的收藏",
              disabled: false,
            },
            {
              index: "/pc/user/wiki/questions",
              label: "我的问答",
              disabled: false,
            },
            {
              index: "/pc/encyclopedia/specification",
              label: "规格书管理",
              disabled: false,
            },
          ],
        },
        {
          label: "账号设置",
          index: "/pc/account-setting",
          icon: "setting",
          disabled: false,
          children: [
            {
              index: "/pc/account-setting/personal-info",
              label: "个人资料",
              disabled: false,
            },
            {
              index: "/pc/account-setting/company-info",
              label: "企业资料",
              disabled: false,
            },
            {
              index: "/pc/account-setting/security",
              label: "安全设置",
              disabled: false,
            },
            {
              index: "/pc/account-setting/verification",
              label: "账号认证",
              disabled: false,
            },
          ],
        },
      ],
      allSubmenuIndexes: [], // 存储所有子菜单的index（用于全部展开）
      wikiReviewerAuthorized: false,
    };
  },
  computed: {
    authToken() {
      return this.$store.getters.token || "";
    },
    // 未读消息数（从 store 读取，实现实时响应）
    unreadCount() {
      return this.$store.state.user.unreadCount || 0;
    },
    userInfo() {
      return this.$store.state.user.userDetails || {};
    },
    // 登录状态
    isLogin() {
      return !!this.$store.getters.token;
    },
    priceChannelContext() {
      return this.$store.state.priceChannelSession?.context || null;
    },
    // 是否显示"申请谈判人"按钮
    showApplyBroker() {
      return this.detail.businessType === 0 && this.detail.shopStatus == null;
    },
    // 用户类型对应的图标
    userTypeIcon() {
      const typeMap = {
        0: "diamond-o",
        10: "records-o",
        20: "user-o",
      };
      return typeMap[this.detail.businessType] || "user-o";
    },
    // 是否有跟单订单（可评价）
    hasFollowOrder() {
      const type = this.detail.businessType;
      return type === 10 || type === 20;
    },
    isAdminUser() {
      const roles = this.detail.roles || this.detail.roleKeys || [];
      return (
        this.detail.isAdmin === true ||
        (Array.isArray(roles) && roles.includes("admin"))
      );
    },
    isWikiReviewer() {
      return (
        this.wikiReviewerAuthorized ||
        isWikiReviewerAccount(
          { ...this.userInfo, ...this.detail },
          this.$store.getters.token
        )
      );
    },
    currentPhone() {
      let storedUser = {};
      try {
        storedUser = JSON.parse(localStorage.getItem("userInfo") || "{}");
      } catch (error) {
        storedUser = {};
      }
      return String(
        this.userInfo.mobile ||
          this.userInfo.phone ||
          this.detail.mobile ||
          this.detail.phone ||
          storedUser.mobile ||
          storedUser.phone ||
          ""
      ).replace(/\D/g, "");
    },
    isFollowManager() {
      return FOLLOW_MANAGER_PHONES.includes(this.currentPhone);
    },
    // 是否为正式服域名
    isProdDomain() {
      const hostname = window.location.hostname;
      return hostname === "www.xsou.com";
    },
    // 动态菜单配置
    menuGroupsWithDisabled() {
      // 复制原始菜单结构
      const menuGroups = JSON.parse(JSON.stringify(this.originMenuGroups));
      // 这些内部管理入口在正式站不展示，开发环境仍保留用于联调。
      const prodHiddenMenuLabels = ["会员等级", "会员身份"];
      const privateRole = Number(this.userInfo.privateRole);
      const isInternalUser = privateRole >= 1 && privateRole <= 9;
      const visibleMenuGroups = menuGroups.filter(
        (item) =>
          (!item.adminOnly || this.isAdminUser) &&
          (!item.internalOnly || isInternalUser) &&
          (!this.isProdDomain || !prodHiddenMenuLabels.includes(item.label))
      );
      const wikiGroup = visibleMenuGroups.find(
        (item) => item.label === "知识百科"
      );
      const bidGroup = visibleMenuGroups.find(
        (item) => item.label === "竞标管理"
      );
      if (bidGroup && Array.isArray(bidGroup.children)) {
        // 跟单经理登录时使用内部工作台文案，其他账号保留普通用户文案。
        bidGroup.children = bidGroup.children.map((item) =>
          item.index === "/pc/bidding-management/follow"
            ? {
                ...item,
                label: this.isFollowManager ? "我的跟单" : "我的跟单员",
              }
            : item
        );
      }
      if (wikiGroup && Array.isArray(wikiGroup.children)) {
        wikiGroup.children = wikiGroup.children.filter(
          (item) => item.index !== "/pc/user/wiki" || this.isWikiReviewer
        );
        if (!this.isWikiReviewer) {
          wikiGroup.index = "/pc/user/wiki/mine";
        }
      }
      if (this.isLogin && priceChannelFlags.readSource === "spring-api") {
        const wikiIndex = visibleMenuGroups.findIndex(
          (item) => item.label === "知识百科"
        );
        visibleMenuGroups.splice(
          wikiIndex >= 0 ? wikiIndex + 1 : visibleMenuGroups.length,
          0,
          priceChannelPersonalMenu(this.priceChannelContext)
        );
      }

      // 需要在正式服禁用的菜单组名称
      const disabledMenuLabels = ["供应需求", "知识百科"];

      // 检查是否有权限查看商品库、品牌管理和供应商管理（privateRole为4、5或6）
      //privateRole-先搜公司内部角色
      // null :不是内部角色、1.业务员、2.业务部门经理、3.业务总监、4.销售商务、5.采购商务、6.商务经理、7.总经理、8.财务、9.出纳
      const hasGoodsLibraryPermission = [4, 5, 6].includes(
        Number(this.userInfo.privateRole)
      );
      const hasShipmentPermission = [1, 2, 3, 4, 6, 7].includes(
        Number(this.userInfo.privateRole)
      );

      // 递归设置disabled属性并过滤菜单
      const processMenuItems = (menuItems) => {
        menuItems.forEach((item, index) => {
          // 检查是否是需要禁用的菜单组
          if (disabledMenuLabels.includes(item.label)) {
            // 是需要禁用的菜单组，根据域名设置disabled
            item.disabled = this.isProdDomain;
            // 递归处理子菜单
            if (item.children && item.children.length > 0) {
              item.children.forEach((child) => {
                child.disabled = this.isProdDomain;
              });
            }
          } else {
            // 不是需要禁用的菜单组，保持默认状态
            item.disabled = false;
            // 递归处理子菜单
            if (item.children && item.children.length > 0) {
              processMenuItems(item.children);
            }
          }
        });
      };

      // 过滤需要权限的菜单（只有privateRole为4、5或6时才显示）
      const filterPermissionMenu = (menuItems) => {
        menuItems.forEach((item, index) => {
          if (item.children && item.children.length > 0) {
            // 过滤需要权限的子菜单
            item.children = item.children.filter((child) => {
              // 发布入口暂时只从侧栏隐藏，保留路由供审核页等既有流程使用。
              if (child.hidden) return false;
              // 竞标全量报价包含所有客户信息，只向超级管理员展示入口。
              if (child.adminOnly && !this.isAdminUser) return false;
              if (child.internalOnly && !isInternalUser) return false;
              if (child.index === "/pc/myxg/reportData") {
                return canViewReportData(this.userInfo.privateRole);
              }
              // 商品库、品牌管理和供应商管理需要 privateRole 为 4、5 或 6
              if (
                child.index === "/pc/myxg/goodsLibrary" ||
                child.index === "/pc/myxg/myBrand" ||
                child.index === "/pc/myxg/supplierList"
              ) {
                return hasGoodsLibraryPermission;
              }
              // 出货管理对业务员、部门经理、业务总监、销售商务、商务经理和总经理可见
              if (child.index === "/pc/follow/outboundOrderList") {
                return hasShipmentPermission;
              }
              return true;
            });
            // 递归处理下一级菜单
            filterPermissionMenu(item.children);
          }
        });
      };

      processMenuItems(visibleMenuGroups);
      filterPermissionMenu(visibleMenuGroups);
      const translateMenuItems = (items) => {
        items.forEach((item) => {
          const key = menuLabelKeys[item.label];
          // 动态简中示例：按 account/index.js 的 menuLabelKeys 翻译显示；权限判断仍使用原标签；完整中文见对应 zh-CN.js，示例不代表固定返回值
          // personalMenu.contractTranslation：合同译文审核
          // personalMenu.contentTranslation：动态译文管理
          // personalMenu.featuredTrading：精选交易
          // personalMenu.wallet：我的钱包
          // personalMenu.orders：交易订单
          // personalMenu.goodsCenter：商品中心
          if (key) item.label = this.$t(key);
          if (item.children) translateMenuItems(item.children);
        });
      };
      // 所有权限、禁用和插入判断均先用稳定原始标签完成，再只翻译显示值。
      translateMenuItems(visibleMenuGroups);
      return visibleMenuGroups;
    },
  },

  created() {
    // 登录状态下才加载数据
    this.isLogin && this.initData();
    this.isLogin && this.checkWikiReviewerAccess();
    if (
      this.isLogin &&
      priceChannelFlags.readSource === "spring-api" &&
      !this.$route.path.startsWith(PRICE_CHANNEL_PERSONAL_BASE)
    ) {
      this.loadPriceChannelIdentity();
    }
  },
  mounted() {
    // 收集所有子菜单的index（用于el-menu的default-openeds属性）
    this.collectAllSubmenuIndexes(this.originMenuGroups);
    if (priceChannelFlags.readSource === "spring-api") {
      this.allSubmenuIndexes.push(PRICE_CHANNEL_PERSONAL_BASE);
    }
  },
  methods: {
    /** H5 商城登录态只提供 Token；频道角色必须向 Spring 重新核对，失败不阻断其他个人中心业务。 */
    loadPriceChannelIdentity() {
      return this.$store
        .dispatch("priceChannelSession/initializeBusiness")
        .catch(() => null);
    },
    // 处理空白区域滚动事件

    // 检查是否授权Wiki审核
    async checkWikiReviewerAccess() {
      try {
        const response = await getWikiReviewAccess();
        this.wikiReviewerAuthorized = Boolean(
          response && response.data && response.data.allowed
        );
      } catch (error) {
        this.wikiReviewerAuthorized = false;
      }
    },
    // 点击logo跳转首页
    handleLogoClick() {
      this.$router.push("/");
    },
    // 初始化数据
    async initData() {
      try {
        // 加载中...
        Toast.loading({
          message: this.$t("personalMenu.loading"),
          duration: 0,
        });
        // 并行请求用户信息和余额（优化性能）
        const [userRes, balanceRes] = await Promise.all([
          this.$store.dispatch("user/ensureUserInfo"),
          getUserBalance(),
        ]);

        if (userRes.code === 200) {
          this.detail = userRes.data.userInfo;
          void this.$store.dispatch("user/refreshUnreadCount").catch(() => console.warn("消息未读汇总刷新失败"));
        }
        if (balanceRes.code === 200) {
          this.balance = balanceRes.data;
        }
      } catch (err) {
        console.error("数据加载失败:", err);
        // 加载失败，请重试
        Toast.fail(this.$t("personalMenu.loadFailed"));
      } finally {
        Toast.clear();
      }
    },
    // 退出登录
    // async logout() {
    //   try {
    //     const confirm = await Dialog.confirm({
    //       title: "温馨提示",
    //       message: "你确认要退出吗？",
    //     });
    //     if (confirm) {
    //       sessionStorage.removeItem("hasTip");
    //       await this.$store.dispatch("user/logout");
    //       // 退出后刷新页面或跳转首页
    //       this.$router.push("/home");
    //     }
    //   } catch (err) {
    //     // 取消退出
    //   }
    // },
    // 页面跳转
    onJump(url) {
      if (!this.isLogin) {
        // 请先登录
        Toast.fail(this.$t("personalMenu.loginFirst"));
        this.$router.push("/login");
        return;
      }
      this.$router.push(url);
    },
    // 头像区域点击事件（未登录时跳转登录）
    handleHeadClick() {
      if (!this.isLogin) {
        this.$router.push("/login");
      }
    },
    // 递归收集所有有子菜单的index（el-submenu的index）
    collectAllSubmenuIndexes(menus) {
      menus.forEach((menu) => {
        if (menu.children && menu.children.length) {
          // 有子菜单：收集当前menu的index
          this.allSubmenuIndexes.push(menu.index);
          // 递归处理下一级菜单
          this.collectAllSubmenuIndexes(menu.children);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@brand-color: #4286f5;
@bg-color: #f5f6f8;
@card-bg: #fff;
@text-regular: #606266;
@border-radius: 16px;
@sidebar-width: 190px;
@gutter-width: 24px;
@content-max-width: 1600px;
@layout-padding: 24px;
// 保持原有起点：公共容器的导航占位 + 本页导航间距；固定侧栏不改变正文位置。
@sidebar-top: (@pc-layout-height * 2 + 12px);

.pc_container {
  --personal-sidebar-anchor: max(24px, calc((100vw - 1600px) / 2 + 24px));
  // 英文先利用左侧空白，保证距窗口至少16px；不足部分再由正文让位。
  --personal-sidebar-left-growth: min(
    calc(var(--personal-sidebar-width, 190px) - 190px),
    max(0px, calc(var(--personal-sidebar-anchor) - 16px))
  );
  height: 100vh;
  background-color: @bg-color;
  // 外层统一承接长页滚动，左右留白与正文使用同一滚动容器。
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-y: contain;
  box-sizing: border-box;

  .main-container {
    width: 100%;
    max-width: @content-max-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: stretch;
    padding: calc(@pc-layout-height + 12px) @layout-padding @layout-padding;
    gap: @gutter-width;
    min-width: 0;
    box-sizing: border-box;
    overflow: visible;

    .sidebar {
      // 固定在视口，不受主容器高度或外层长页滚动影响；宽屏仍与居中内容左边缘对齐。
      position: fixed;
      top: @sidebar-top;
      left: calc(
        var(--personal-sidebar-anchor) - var(--personal-sidebar-left-growth)
      );
      z-index: 1;
      width: var(--personal-sidebar-width, @sidebar-width);
      height: calc(100vh - @sidebar-top - @layout-padding);
      min-height: 0;
      flex-shrink: 0;
      background: transparent;
      border-radius: @border-radius;
      overflow: visible;
      contain: layout style;
      overscroll-behavior-y: contain;

      .sidebar-surface {
        position: absolute;
        inset: 0;
        border-radius: inherit;
        background: @card-bg;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transform-origin: left top;
        pointer-events: none;
      }

      .side-menu {
        position: relative;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        // 到达首尾后只停在菜单内，不把滚动继续传给外层正文。
        overscroll-behavior-y: contain;
        display: flex;
        flex-direction: column;
        background: transparent;
        border-radius: @border-radius;

        // 仅在个人中心覆盖递归菜单：由side-menu单独滚动，避免每层再嵌套滚动区。
        ::v-deep .menu-recursive {
          flex: 0 0 auto;
          overflow: visible;
        }
      }
    }

    .main-content {
      flex: 1;
      // 侧栏固定后脱离文档流，原位保留侧栏宽度和两栏间距，防止正文被遮挡。
      margin-left: calc(
        var(--personal-sidebar-width, @sidebar-width) + @gutter-width -
          var(--personal-sidebar-left-growth)
      );
      height: 100%;
      min-height: 0;
      min-width: 0;
      max-width: 100%;
      // 保留明确高度供消息中心等视口型页面继承；自然长页向外展开，由外层滚动。
      // 两轴一起放开，避免overflow-x:hidden使纵向visible被计算成auto。
      overflow: visible;
      border-radius: @border-radius;
      background-color: @bg-color;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
      }
    }
  }
}

:deep(.side-menu) {
  border-right: none;

  .el-submenu__title,
  .el-menu-item {
    color: @text-regular !important;
  }

  .el-menu-item.is-active {
    color: @brand-color !important;
    background-color: rgba(66, 134, 245, 0.12) !important;
  }
}
</style>
